import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var res;
export const addGateTodo = createAsyncThunk('addGate', async (data) => {
    try {
        const formData = new FormData();
        formData.append('name', data.name);
        formData.append('detail', data.detail);
        formData.append('password', data.password);
        formData.append('path', 'category');
        formData.append('latitude', data.latitude);
        formData.append('longitude', data.longitude);
        formData.append('status', data.status);
        formData.append('user_phone', data.user_phone);
        if (data.gate_image) {
            formData.append('gate_image', data.gate_image);
        }

        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'gate',
            data: formData,
            headers: { "Content-Type": "multipart/form-data", "Authorization": 'Bearer ' + localStorage.getItem('token') }
        })
        return res

    } catch (error) {
        return error?.response
    }
})


